import type { LinkHTMLAttributes } from 'react';

import { useIsBot } from '@packages/tracking/src/hooks/useIsBot/useIsBot';

import { getCanonicalUrl } from '../../utils/getCanonicalUrl/getCanonicalUrl';
import { cn } from '../../utils/cn/cn';

const Anchor = ({ className, ...props }: LinkHTMLAttributes<HTMLAnchorElement>) => {
  const { children, href } = props;
  let linkTarget = href;
  const isBot = useIsBot();
  if (isBot) {
    linkTarget = getCanonicalUrl(href ?? '');
  }

  return (
    <a
      {...props}
      className={cn(
        'text-color-text-dark hover:text-color-grey-dark text-size-body-base underline',
        className,
      )}
      href={linkTarget}
    >
      {children}
    </a>
  );
};

export { Anchor };
